<template>
  <div>
    <section class="content cleafix" v-if="step === 1">
      <form>
        <h1 class="form-head">
          用户注册
        </h1>
        <div class="form-body">
          <div class="input-item clearfix p-t-xs">
            <div class="col-xs-6 n-p-l">
              <div class="col-xs-12 inline-block btn btn-md text-center" @click="category=1" :class="{'btn-primary':category===1}">普通用户注册</div>
            </div>
            <div class="col-xs-6 n-p-r">
              <div class="col-xs-12 inline-block btn btn-md text-center right" @click="category=2" :class="{'btn-primary':category===2}">校企用户注册</div>
            </div>
          </div>
          <div class="input-item" v-show="category === 1">
            <input type="text" class="input" name="nickname" placeholder="昵称：风清扬" required="required" v-model.trim="nickname" autocomplete="off" @blur="checkUserNickname()">
            <span class="input-tips">{{error.nickname}}</span>
          </div>
          <div class="input-item clearfix p-t-xs" v-show="category === 2">
            <span class="lab">类型：</span>
            <label class="m-r-sm" style="cursor:pointer;" for="category-company">
              <input type="radio" v-model.number="ccategory" class="m-r-xs" value="1" id="category-company">公司
            </label>
            <label class="m-r-sm" style="cursor:pointer;" for="category-school">
              <input type="radio" v-model.number="ccategory" class="m-r-xs" value="2" id="category-school">学校
            </label>
          </div>
          <div class="input-item" v-if="category === 2 && ccategory===1">
            <input type="text" class="input" name="companyName" placeholder="公司名称：XX公司" required="required" v-model.trim="companyName" autocomplete="off" @blur="checkCompanyName()">
            <span class="input-tips">{{error.companyName}}</span>
          </div>
          <div class="input-item" v-if="category === 2 && ccategory===2">
            <input type="text" class="input" name="companyName" placeholder="学校名称：XX大学" required="required" v-model.trim="companyName" autocomplete="off" @blur="checkCompanyName()">
            <span class="input-tips">{{error.companyName}}</span>
          </div>
          <div class="input-item" v-if="category === 2 && ccategory===1">
            <input type="text" class="input" name="username" placeholder="企业邮箱：service@lechenggu.com" required="required" v-model.trim="username" autocomplete="off" @blur="checkEmail()">
            <span class="input-tips">{{error.username}}</span>
          </div>
          <div class="input-item" v-if="category === 2 && ccategory===2">
            <input type="text" class="input" name="username" placeholder="学校邮箱：service@lechenggu.com" required="required" v-model.trim="username" autocomplete="off" @blur="checkEmail()">
            <span class="input-tips">{{error.username}}</span>
          </div>
          <div class="input-item" v-if="category === 1">
            <input type="text" class="input" name="username" placeholder="用户名：邮箱或手机号" required="required" v-model.trim="username" autocomplete="off" @blur="checkUsername()">
            <span class="input-tips">{{error.username}}</span>
          </div>
          <div class="input-item clearfix">
            <div class="col-xs-12 clearfix">
              <div class="row clearfix">
                <div class="col-sm-7 n-p-l">
                  <input type="text" class="input" v-model.trim="verifyCode" placeholder="验证码：6位" @blur="validateCode()">
                </div>
                <div class="col-sm-5 n-p-r n-p-l">
                  <button type="button" class="btn btn-md btn-primary col-xs-12" :disabled="reset.disabled" @click="sendVerifyCode()">{{reset.text}}</button>
                </div>
              </div>
              <div class="row">
                <span class="input-tips">{{error.code}}</span>
              </div>
            </div>
          </div>
          <div class="input-item">
            <input type="password" class="input" name="password" placeholder="密码：6-16位字符、数字、特殊字符" required="required" v-model.trim="password" autocomplete="off">
          </div>
          <div class="input-item">
            <input type="password" class="input" name="rpassword" placeholder="再次输入：6-16位字符、数字、特殊字符" required="required" v-model.trim="rpassword" autocomplete="off">
            <span class="input-tips">{{error.password}}</span>
          </div>
          <div class="input-item clearfix">
            <button class="btn btn-md btn-primary col-xs-12" :disabled="disabled" @click="registerFunc()">注&nbsp;&nbsp;&nbsp;&nbsp;册</button>
          </div>
          <div class="input-item">
            <h5 class="reg_now">已有帐号？
              <router-link :to="{ name: '/auth/login', params: {}}" class="color-primary ">直接登录</router-link>
              <router-link :to="{ name: '/auth/reset_password', params: {}}" class="color-primary right">忘记密码?</router-link>
            </h5>
          </div>
        </div>
      </form>
    </section>
    <section class="content" v-if="step === 2">
      <div class="init-content">
        <div class="step-content">
          <form v-if="category === 1" class="company-info">
            <h1 class="form-head">
              <i class="step">2.</i> 完善个人信息</h1>
            <div class="input-item n-m-b">
              <div class="logo">
                <img :alt="user.nickname" :src="user.avatar">
                <input type="file" class="hidden-file" name="file" accept="image/*" @change="uploadAvatar($event)">
              </div>
            </div>
            <div class="input-item show-info text-center">
              <span class="email">{{user.nickname}}</span>
            </div>
            <div class="input-item">
              <input type="text" class="input" placeholder="真实姓名：华宇互联" required="required" v-model.trim="user.realname" autocomplete="off">
            </div>
            <div class="input-item">
              <input type="text" class="input" placeholder="QQ：10000" required="required" v-model.trim="user.qq" autocomplete="off">
            </div>
            <div class="input-item">
              <textarea class="input textarea" resize="none" placeholder="个性签名：人在江湖飘，就是要挨刀！" required="required" v-model.trim="user.signature" autocomplete="off"></textarea>
            </div>
            <div class="input-item">
              <button class="btn btn-md btn-primary col-xs-12" type="button" @click="completeInfo()">完成注册</button>
            </div>
          </form>
          <!-- / user end -->
          <form v-if="category === 2" class="company-info">
            <h1 class="form-head">
              <i class="step">2.</i> 完善{{ccategory === 1 ? '公司':'学校'}}信息</h1>
            <div class="input-item">
              <div class="logo">
                <img :alt="company.name" :src="company.logo">
                <input type="file" class="hidden-file" name="file" @change="uploadLogo(event)">
              </div>
            </div>
            <div class="input-item show-info text-center">
              <span class="email">{{companyName}}</span>
            </div>
            <div class="input-item" v-if="ccategory === 1 ">
              <input type="text" class="input" placeholder="公司简称，比如：华宇互联" required="required" v-model.trim="company.short_name" autocomplete="off">
            </div>
            <div class="input-item" v-if="ccategory === 2">
              <input type="text" class="input" placeholder="学校简称，比如：华宇互联" required="required" v-model.trim="company.short_name" autocomplete="off">
            </div>
            <div class="input-item" v-if="ccategory === 1">
              <input type="text" class="input" placeholder="信用代码，比如：918888888888888888" required="required" v-model.trim="company.credit_code" autocomplete="off">
            </div>
            <div class="split">
              <div class="b-b b-dashed m-b-xs"></div>
            </div>
            <div class="input-item">
              <input type="text" class="input" placeholder="常用联系人，比如：王小帅" required="required" v-model.trim="company.principal.name" autocomplete="off">
            </div>
            <div class="input-item">
              <input type="text" class="input" placeholder="联系人电话，比如：1888888888" required="required" v-model.trim="company.principal.phone" autocomplete="off">
            </div>
            <div class="input-item">
              <div class="col-xs-12">
                <div class="row">
                  <div class="col-xs-6 n-p-l">
                    <input type="button" class="btn btn-md btn-primary col-xs-12" value="跳过，直接使用" @click="skipComplete()">
                  </div>
                  <div class="col-xs-6 n-p-r">
                    <input type="button" class="btn btn-md btn-primary col-xs-12" value="完成注册" @click="completeInfo()">
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    <!-- / register end /-->
  </div>
</template>
<script>
import WebUploader from "webuploader";
import Auth from "../../resource/auth";
export default {
  data: function() {
    return {
      category: 1,
      ccategory: 1,
      username: "",
      email: "",
      phone: "",
      password: "",
      rpassword: "",
      companyName: "",
      nickname: "",
      verifyCode: "",
      disabled: true,
      error: {
        email: "",
        phone: "",
        password: "",
        code: "",
        nickname: "",
        username: ""
      },
      validate: [0, 0, 0, 0],
      step: 1,
      reset: {
        text: "发送验证码",
        disabled: false,
        timer: null,
        seconds: 60
      },
      register: {
        disabled: true,
        validate: [0, 0]
      },
      company: {
        logo: "/assets/images/default-company-logo.png",
        name: "",
        short_name: "",
        credit_code: "",
        principal: {
          name: "",
          phone: ""
        }
      },
      user: {
        nickname: "",
        realname: "",
        avatar: "/assets/images/default-user-avatar.png",
        qq: "",
        signature: ""
      },
      uploader: null
    };
  },
  computed: {
    validateFlag: function() {
      const that = this;
      let tmp = that.validate.join("");
      return tmp;
    }
  },
  created: function() {
    document.title = `用户注册|${this.global.name}`;
  },
  watch: {
    password: function(now, pre) {
      const that = this;
      that.disabled = true;
      if (now !== pre) {
        that.validate[2] = 0;
      }
      if (that.password === "") {
        that.validate[2] = 0;
        that.error.password = "";
        return;
      }
      if (!that.global.regex.password.test(that.password)) {
        that.validate[2] = 0;
        that.error.password = "格式错误：6-16位字符、数字、特殊字符至少包含两种";
        return;
      }
      if (that.password === that.rpassword) {
        that.validate[2] = 1;
        that.error.password = "";
        that.disabled = that.validate.join("") !== "1111";
      } else {
        that.validate[2] = 0;
        if (!that.rpassword) {
          that.error.password = "";
        } else {
          that.error.password = "两次输入的密码不一致";
        }
      }
    },
    rpassword: function(now, pre) {
      const that = this;
      that.disabled = true;
      if (now !== pre) {
        that.validate[2] = 0;
      }
      if (that.rpassword === "") {
        that.validate[2] = 0;
        that.error.password = "";
        that.disabled = that.validate.join("") !== "1111";
        return;
      }
      if (!that.global.regex.password.test(that.rpassword)) {
        that.validate[2] = 0;
        that.error.password = "格式错误：6-16位字符、数字、特殊字符至少包含两种";
        return;
      }
      if (that.password === that.rpassword) {
        that.validate[2] = 1;
        that.error.password = "";
        that.disabled = that.validate.join("") !== "1111";
      } else {
        that.validate[2] = 0;
        that.error.password = "两次输入的密码不一致";
      }
    },
    category: function() {
      const that = this;
      that.clear();
    },
    ccategory: function() {
      const that = this;
      that.company.logo =
        that.ccategory === 1
          ? "/assets/images/default-company-logo.png"
          : "/assets/images/default-school-logo.png";
    }
  },
  methods: {
    checkUsername: function() {
      const that = this;
      that.reset.disabled = true;
      if (!that.username) {
        that.validate[0] = 0;
        that.error.username = "请输入用户名";
        return false;
      }
      if (that.global.regex.email.test(that.username)) {
        that.email = that.username;
        that.phone = "";
        that.checkEmail();
      } else if (that.global.regex.phone.test(that.username)) {
        that.phone = that.username;
        that.email = "";
        that.checkPhone();
        return true;
      } else {
        that.validate[0] = 0;
        that.error.username = "格式错误：常用邮箱或手机号";
        return false;
      }
    },
    checkEmail: function() {
      const that = this;
      that.reset.disabled = true; // 禁用按钮
      that.disabled = true; // 禁用注册按钮
      if (that.global.regex.email.test(that.username)) {
        that.error.username = "";
        Auth.checkEmail({
          email: that.username,
          category: that.category
        }).then(res => {
          if (res.status === 200) {
            let data = res.body;
            if (data.code === 0) {
              // 校验成功
              that.validate[0] = 1; // 设置标识位
              that.disabled = that.validate.join("") !== "1111"; // 判断注册状态
              that.error.username = ""; // 设置错误
              that.reset.disabled = false; // 启用按钮
            } else {
              that.validate[0] = 0;
              that.disabled = true; // 禁用注册按钮
              that.error.username = "该邮箱已经注册，请直接登录";
            }
          } else {
            alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
          }
        });
      } else {
        that.validate[0] = 0;
        that.error.username = "请输入正确的邮箱地址";
      }
    },
    checkPhone: function() {
      const that = this;
      that.reset.disabled = true; // 禁用按钮
      if (that.global.regex.phone.test(that.username)) {
        that.error.username = "";
        Auth.checkPhone({
          phone: that.username,
          category: that.category
        }).then(
          res => {
            let data = res.body;
            if (data.code === 0) {
              // 校验成功
              that.validate[0] = 1;
              that.disabled = that.validate.join("") !== "1111";
              that.error.username = "";
              that.reset.disabled = false; // 启用按钮
            } else {
              that.validate[0] = 0;
              that.error.username = "该手机号已经注册，请直接登录";
            }
          },
          res => {
            alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
          }
        );
      } else {
        that.validate[0] = 0;
        that.error.username = "请输入正确的手机号";
      }
    },
    sendVerifyCode: function() {
      const that = this;
      that.reset.disabled = true; // 禁用按钮
      // 发送验证码
      Auth.sendVerifyCode({ username: that.username }).then(res => {
        let data = res.body;
        if (data.code === 0) {
          // 校验成功
          that.reset.seconds = 60;
          that.reset.text = `${that.reset.seconds}s后，重发`;
          that.reset.timer = setInterval(() => {
            // 倒计时
            if (that.reset.seconds === 0) {
              that.reset.disabled = false;
              that.reset.text = `发送验证码`;
              clearInterval(that.reset.timer);
              that.reset.timer = null;
            } else {
              that.reset.seconds--;
              that.reset.text = `${that.reset.seconds} s后，重发`;
            }
          }, 1000);
        } else {
          that.reset.disabled = false;
          alert(data.msg);
        }
      });
    },
    validateCode: function() {
      const that = this;
      that.disabled = true;
      if (that.verifyCode == "") {
        that.validate[1] = 0;
        that.error.code = "请输入验证码";
        return;
      }
      if (that.global.regex.code.test(that.verifyCode)) {
        that.error.code = "";
        that.validate[1] = 1;
        that.disabled = that.validate.join("") !== "1111";
      } else {
        that.error.code = "请输入正确的验证码";
        that.validate[1] = 0;
        that.disabled = true;
      }
    },
    registerFunc: function() {
      const that = this;
      if (that.disabled) {
        alert("请填写完成验证信息后，再进行下一步操作");
        return;
      }
      that.disabled = true;
      let user = {
        password: that.password,
        category: that.category,
        verifyCode: that.verifyCode
      };
      let cb = res => {
        if (res.status === 200) {
          let data = res.body;
          if (data.code === 0) {
            // 校验成功
            if (that.category === 1) {
              that.user = data.result;
              that.user.avatar = "/assets/images/default-user-avatar.png";
            } else {
              that.company.name = that.companyName;
            }
            that.disabled = true;
            that.step = 2;
            that.uploader = WebUploader.create({
              auto: true,
              server: "/api/upload",
              pick: {
                multiple: false
              },
              accept: {
                title: "Images",
                extensions: "gif,jpg,jpeg,bmp,png",
                mimeTypes: "image/*"
              },
              formData: {}
            });
          } else {
            that.disabled = false;
            alert(data.msg);
          }
        } else {
          alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
        }
      };
      if (that.category === 2) {
        user.email = that.username;
        user.companyName = that.companyName;
        user.company_category = that.ccategory;
        Auth.registerByEmail({}, user).then(cb);
      } else {
        user.nickname = that.nickname;
        user.username = that.username;
        Auth.userRegister({}, user).then(cb);
      }
    },
    uploadAvatar: function(event) {
      const that = this;
      that.uploader.on("uploadSuccess", (file, res) => {
        if (res.code === 0) {
          that.user.avatar = res.result.url;
        } else {
          alert(res.msg);
        }
      });
      that.uploader.addFile(event.target.files[0]);
    },
    uploadLogo: function(event) {
      const that = this;
      that.uploader.on("uploadSuccess", (file, res) => {
        if (res.code === 0) {
          that.company.avatar = res.result.url;
        } else {
          alert(res.msg);
        }
      });
      that.uploader.addFile(event.target.files[0]);
    },
    checkCompanyName: function() {
      const that = this;
      if (that.companyName) {
        that.error.companyName = "";
        that.$http
          .get(`/api/v1/companies/check_name?name=${that.companyName}`)
          .then(res => {
            if (res.status === 200) {
              let data = res.body;
              if (data.code === 0) {
                // 校验成功
                that.validate[3] = 1;
                that.disabled = that.validate.join("") !== "1111";
              } else if (data.code === 50) {
                that.validate[3] = 0;
                that.disabled = true;
                that.error.companyName = "该公司已经加入平台，如有疑问请与管理员联系。";
              } else {
                that.validate[3] = 0;
                that.disabled = true;
                alert(data.msg);
              }
            } else {
              alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
            }
          });
      } else {
        that.register.validate[3] = 0;
        that.register.disabled = true;
        that.error.companyName = "请输入公司名称";
      }
    },
    checkUserNickname: function() {
      const that = this;
      if (that.nickname) {
        that.error.nickname = "";
        that.validate[3] = 1;
        that.disabled = that.validate.join("") !== "1111";
      } else {
        that.validate[3] = 0;
        that.disabled = true;
        that.error.nickname = "请输入昵称";
      }
    },
    skipComplete: function() {
      const that = this;
      that.$router.push("/");
    },
    completeInfo: function() {
      const that = this;
      that.$http
        .put("/api/v1/users/", that.category === 1 ? that.user : that.company)
        .then(res => {
          if (res.status === 200) {
            let data = res.body;
            if (data.code === 0) {
              // 校验成功
              that.$router.push("/");
            } else {
              alert(data.msg);
            }
          } else {
            alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
          }
        });
    },
    clear: function() {
      const that = this;
      that.email = "";
      that.password = "";
      that.phone = "";
      that.rpassword = "";
      that.companyName = "";
      that.ccompany = 1;
      that.verifyCode = "";
      that.nickname = "";
      that.error = {
        email: "",
        phone: "",
        password: "",
        code: "",
        nickname: "",
        companyName: ""
      };
      that.validate = [0, 0, 0];
      that.disabled = true;
    }
  }
};
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// register.vue?381c9382